// src/features/auth/auth.routes.js
import AuthView from './AuthView.vue';

const authRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: AuthView,
    meta: {
      requiresAuth: false, // Login page does not require authentication
      // You might add a meta field like 'isGuestPage: true' to redirect authenticated users away
    },
  },
];

export default authRoutes;
